'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("inputTypeColor", function ($timeout, tlColors) {
  var colorPalette = [[tlColors.WHITE, '#e9ecf3', '#BEBEBE', '#808080', tlColors.BLACK],
  // greyscales
  [tlColors.NEW_LIGHT_BLUE, tlColors.NEW_BLUE_1, tlColors.NEW_BLUE_2, tlColors.NEW_PURPLE_1, tlColors.NEW_PURPLE_2], [tlColors.NEW_GREEN_1, tlColors.NEW_GREEN_2, tlColors.NEW_GREEN_3, tlColors.NEW_GREEN_4, tlColors.NEW_BLACK_1], [tlColors.DARK_YELLOW, tlColors.NEW_ORANGE_1, tlColors.NEW_ORANGE_2, tlColors.NEW_RED_1, tlColors.NEW_RED_2], [tlColors.FUSCHIA, '#bfd7ff', '#15a3ef', '#322f8f', '#2a2758'],
  // fuschia + blues
  ['#ffc902', '#F48600', '#4DC100', '#bb4040', '#ff31dd'] // some colors from colors.less
  ];
  return {
    restrict: "A",
    require: "ngModel",
    link: function link($scope, $el, $attrs, modelCtrl) {
      $scope.$watch(function () {
        return modelCtrl.$modelValue;
      }, function (modelValue) {
        $el.spectrum("set", modelValue);
      });
      var onShow = function onShow() {
        $timeout(function () {
          $el.trigger("focusin");
        }, 0, false);
      };
      var onChange = function onChange(color) {
        if (modelCtrl.$modelValue !== (color ? color.toHexString() : null)) {
          $scope.$apply(function () {
            modelCtrl.$setViewValue(color ? color.toHexString() : null);
          });
          $timeout(function () {
            $el.trigger("blur");
          }, 20, false);
        }
      };
      var opts = {
        color: modelCtrl.$modelValue,
        show: onShow,
        change: onChange,
        hide: onChange,
        preferredFormat: "hex",
        // todo -i18n - idealement devrait utiliser le fichier de resource de langue, mais pas trouvé comment le faire prendre en charge
        cancelText: "Annuler",
        chooseText: "Valider",
        clearText: "Effacer couleur sélectionnée",
        noColorSelectedText: "Aucune couleur sélectionnée",
        togglePaletteMoreText: "Plus",
        togglePaletteLessText: "Moins",
        theme: "sp-taelys",
        showInput: true,
        showInitial: true,
        allowEmpty: true,
        showPalette: true,
        palette: colorPalette
      };
      $el.spectrum(opts);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/inputTypes/inputTypeColor.js
// module id = 2946
// module chunks = 13